import { ReactElement, useCallback } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { Button } from 'dibs-elements/exports/Button';
import { Spinner } from 'dibs-elements/exports/Spinner';
import { LoadMoreFn } from 'react-relay';
import { OperationType } from 'relay-runtime';

import styles from './NftProfileSections.scss';

type HandleClickProps = { loadNext?: never; count?: never; onClick: () => void };
type LoadNextProps<T extends OperationType> = {
    loadNext: LoadMoreFn<T>;
    count: number;
    onClick?: never;
};
type NftProfileSectionLoadMoreType = <T extends OperationType>(
    props: {
        hasNext: boolean;
        isLoadingNext: boolean;
    } & (HandleClickProps | LoadNextProps<T>)
) => ReactElement | null;

export const NftProfileSectionLoadMore: NftProfileSectionLoadMoreType = ({
    hasNext,
    isLoadingNext,
    onClick,
    loadNext,
    count,
}) => {
    const loadMoreCallback = useCallback(() => loadNext?.(count), [loadNext, count]);
    if (!hasNext) {
        return null;
    }

    return (
        <div className={styles.viewMoreContainer}>
            {isLoadingNext ? (
                <Spinner black />
            ) : (
                <Button
                    type="secondary"
                    size="medium"
                    onClick={onClick || loadMoreCallback}
                    className={styles.viewMoreButton}
                >
                    <FormattedMessage
                        id="nftProfile.auctions.viewMore"
                        defaultMessage="View More"
                    />
                </Button>
            )}
        </div>
    );
};
